import React, {ReactNode} from 'react'

interface Props<A extends string> {
    action: A
    title: string
    onAction: (action: A) => void
    children: ReactNode
}

export function AlignWidgetButton<A extends string>({action, title, onAction, children}: Props<A>) {
    const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()
        event.preventDefault()
        onAction(action)
    }

    return (
        <button
            className='align-widgets-bar__button'
            onMouseDown={onClick}
            title={title}
            type='button'
        >
            {children}
        </button>
    )
}
